export const HAS_CLOSED_NOT_VALID_VOUCHER_MESSAGE = 'hasClosedNotValidVoucherMessage' as const;
export const CFC_REDIRECT_URL = 'CFCRedirectUrl';
